import Axios from "../helper/axios";
import { urls } from "../constants/constants";

const axios = new Axios();

export default class DepartmentService {
  getDepartmentsByPractiseId(practiceId, page = 1, searchQuery = "") {
    const option = {
      url: `${urls.aspariaBackend}api/v1/getDepartmentsByPracticeId${
        practiceId ? "?practiceId=" + practiceId : ""
      }${page ? "&page=" + page : ""}${
        searchQuery ? "&name=" + searchQuery : ""
      }`,
    };
    return axios.get(option);
  }

  getUsersByDepartmentId(departmentId, page = 1, searchQuery = "") {
    const option = {
      url: `${urls.aspariaBackend}api/v1/getUsersByDepartmentId${
        departmentId ? "?departmentId=" + departmentId : ""
      }${page ? "&page=" + page : ""}${
        searchQuery ? "&name=" + searchQuery : ""
      }`,
    };
    return axios.get(option);
  }
}
